import { useEffect, useMemo } from "react"

import { App, Col, Divider, Flex, Row, Spin, Tooltip, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useLocation, useNavigate } from "react-router-dom"

// import TransactionModal from '../../Components/Modal/TransactionModal'
import ButtonComponent from "../../Components/Button"
import Private from "../../Components/Private"
import Table from "../../Components/Table"
import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Icon from "../../Icon"
import utils from "../../Utils/utils"
import { getPaymentProcessors } from "../User/redux/user.thunks"
import { CreateTicketModal } from "./components/CreateTicketModal"
import { CreditRequestModal } from "./components/CreditRequestModal"
import LostLegacyNotification from "./components/LostLegacyNotification/LostLegacyNotification"
import { OverviewInfo } from "./components/OverviewInfo"
import { getLogsColumns } from "./components/Table/columns"
import Creators from "./reducer"
import { useAlertsPageQuery } from "./useAlertsPageQuery"

// import { useAlertStatusTransactionFlow } from './hooks/useAlertStatusTransactionFlow'

const { Text } = Typography

export const AlertDetailsPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { notification } = App.useApp()
  const { t } = useTranslation()
  const { pathname, search } = useLocation()
  const { alert_id } = useParams()
  const externalDemoMode = useExternalDemoMode()

  const { business_account_id } = useAlertsPageQuery(search)

  const {
    fetching,
    alertDetailsFetching,
    alertDetails,
    alertLogsFetching,
    alertLogs,
    saveFetching,
    saveResult,
    transactionModalSaving,
    transactionModalError
  } = useSelector((state) => state.alerts)

  const showLegacyLostNotification = alertDetails?.show_legacy_lost_notification

  const { userInfo } = useSelector((state) => state.auth)
  const paymentProcessors = useSelector((state) => state.user.paymentProcessors)
  const isAdmin = useSelector((state) => state.auth.isAdmin)
  const isDemo = userInfo?.is_demo
  const isBusinessAccountAdministrator = userInfo?.ba_role?.name === "Administrator"
  const isDemoRestricted = isDemo && !isBusinessAccountAdministrator
  const isMobile = useSelector((state) => state.nav.isMobile)
  const isDemoModeBlocked = !userInfo.current_business_account_id && !isAdmin

  const notificationConfig = {
    closeIcon: <Text>{t("Dismiss")}</Text>,
    placement: isMobile ? "topRight" : "topRight",
    style: isMobile ? { fontSize: 12 } : { minWidth: "max-content" }
  }
  // TODO: CHA-6795
  // const getAlertById = useCallback((currentAlertId) => {
  //   return alertDetails?.alert_id === currentAlertId ? alertDetails : null
  // }, [alertDetails])
  // TODO: CHA-6795
  // const transactionModalProcessors = useMemo(
  //   () => paymentProcessors
  //     ?.filter((processor) => processor?.is_active && processor?.is_connected)
  //     ?.map((processor) => processor?.service_name)
  //     ?.filter(Boolean) || [],
  //   [paymentProcessors]
  // )
  //TODO: CHA-6795
  // const canOpenTransactionModal = useMemo(
  //   () => transactionModalProcessors.some((processor) => processor !== 'manual_refunds'),
  //   [transactionModalProcessors]
  // )
  // const {
  //   transactionModalAlert,
  //   openTransactionModal,
  //   closeTransactionModal,
  //   submitAlertStatusChange,
  //   saveTransactionModalData,
  //   transactionModalInitialValue,
  // } = useAlertStatusTransactionFlow({
  //   onStatusUpdate: (payload) => dispatch(Creators.updateAlertFromDetailsPage(payload)),
  //   onTransactionSave: (payload) => dispatch(Creators.updateAlertTransactionRequest({
  //     ...payload,
  //     refreshDetails: true,
  //   })),
  //   getAlertById,
  //   onClearTransactionError: () => dispatch(Creators.alertsSetProp('transactionModalError', null)),
  //   canOpenTransactionModal,
  // })

  useEffect(() => {
    if (!userInfo?.current_business_account_id) return

    dispatch(
      getPaymentProcessors({
        integrationsPage: true,
        merchant_id: userInfo.current_business_account_id
      })
    )
  }, [dispatch, userInfo?.current_business_account_id])

  useEffect(() => {
    let container = document?.getElementById("main-content")
    container?.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (alert_id) {
      dispatch(Creators.getAlertDetailsRequest(alert_id))
      dispatch(Creators.getAlertLogsRequest(alert_id))
    }
  }, [alert_id])

  useEffect(() => {
    // TODO: CHA-6795 will add 'alert_transaction_update'
    if (["alert_details_export", "ticket_create"]?.includes(saveResult)) {
      if (saveResult === "alert_details_export") {
        notification.success({
          message: t("Your alert has been successfully downloaded."),
          ...notificationConfig,
          placement: "bottomRight"
        })
      } else if (saveResult === "ticket_create") {
        notification.success({
          message: t("Support ticket submitted"),
          description: t(
            "Thank you for reaching out! Your support ticket has been created successfully. The support team will contact you shortly to assist."
          ),
          ...notificationConfig,
          style: { minWidth: 475, width: 475 }
        })
        if (alert_id) dispatch(Creators.getAlertLogsRequest(alert_id))
      }
      // TODO: CHA-6795
      // else if (saveResult === 'alert_transaction_update') {
      // notification.success({
      //   message: t('Transaction data saved'),
      //   description: t('Transaction ID has been saved successfully.'),
      //   ...notificationConfig,
      // })
      // closeTransactionModal()
      // }
      dispatch(Creators.alertsSetProp("saveResult", null))
    }
  }, [alert_id, dispatch, notification, saveResult, t])

  const copy = () => {
    if (alertDetails) {
      let url = process.env.REACT_APP_BASE_URI + pathname + search
      utils.copyToClipboard(url)
      notification.success({
        message: t("Link has been copied to the clipboard"),
        ...notificationConfig
      })
    }
  }

  const handleExport = () => {
    dispatch(Creators.getAlertDetailsExportRequest(alertDetails?.alert_id))
  }
  const handleCreditRequest = () => {
    alert("handleCreditRequest")
  }

  const getTableColumns = useMemo(() => getLogsColumns({ t }), [])

  const goBack = () => {
    if (business_account_id) {
      navigate(
        `/admin/alerts?open_alert=${alertDetails?.alert_id}&business_account_id=${business_account_id}`
      )
    } else {
      navigate(`/alerts?open_alert=${alertDetails?.alert_id}`)
    }
  }

  return (
    <Spin spinning={alertDetailsFetching || fetching}>
      <div
        className={cls("alerts-page", {
          "alerts-page_users_view_for_admin": business_account_id
        })}
      >
        <Flex vertical={true} gap={16}>
          <Flex
            align="center"
            justify="space-between"
            style={{
              flexDirection: isMobile && "column",
              paddingTop: isMobile && 35
            }}
          >
            <Flex
              gap={8}
              align={!isMobile ? "center" : "flex-start"}
              style={{
                width: isMobile && "100%",
                alignItems: isMobile && "center",
                marginBottom: isMobile && 12
              }}
            >
              <ButtonComponent
                type="text"
                icon={<Icon type="arrow_left" />}
                style={{ width: 32 }}
                onClick={goBack}
              />
              <Text
                strong
                style={{
                  fontSize: !isMobile ? 18 : 16,
                  lineHeight: !isMobile ? 1.4 : "20px"
                }}
              >
                {t("Alert details & activity")}
              </Text>
            </Flex>

            <Flex
              gap={isMobile ? 8 : 12}
              style={{
                width: isMobile && "100",
                justifyContent: isMobile && "space-between",
                flexDirection: isMobile && "row-reverse"
              }}
            >
              <Tooltip title={t("Copy alert link")}>
                <ButtonComponent
                  onClick={copy}
                  icon={<Icon type="link" />}
                  style={{ width: 32 }}
                  disabled={externalDemoMode}
                />
              </Tooltip>
              <Tooltip title={t("Export alert")}>
                <ButtonComponent
                  onClick={handleExport}
                  icon={<Icon type="arrow_inbox" />}
                  style={{ width: 32 }}
                  loading={saveFetching}
                  disabled={isDemoRestricted || externalDemoMode || isDemoModeBlocked}
                />
              </Tooltip>
              <CreditRequestModal
                isDemo={isDemoRestricted}
                alert_id={alert_id}
                showIcon={!isMobile}
              />
              <CreateTicketModal
                isDemo={isDemoRestricted}
                externalDemoMode={externalDemoMode}
                showIcon={!isMobile}
              />
            </Flex>
          </Flex>

          {showLegacyLostNotification && <LostLegacyNotification />}

          <Row
            gutter={0}
            style={{
              margin: "8px 0 16px",
              flexDirection: isMobile && "column"
            }}
            wrap={false}
            align={"stretch"}
          >
            <Col flex="1 1 50%" style={{ padding: !isMobile ? 24 : "16px 0" }}>
              <Flex vertical={true} gap={4} style={{ marginBottom: 24 }}>
                <Text type="secondary">{t("Alert ID")}</Text>
                <Text
                  strong
                  style={{
                    fontSize: !isMobile ? 20 : 16,
                    lineHeight: !isMobile ? 1.4 : "20px"
                  }}
                >
                  <Private>{alertDetails?.alert_id || alert_id}</Private>
                </Text>
              </Flex>
              <OverviewInfo
                data={alertDetails}
                type="fullPageLeft"
                //TODO: CHA-6795
                // onOpenTransactionModal={canOpenTransactionModal ? openTransactionModal : null}
                // onSubmitAlertStatusChange={submitAlertStatusChange}
                onOpenTransactionModal={null}
                onSubmitAlertStatusChange={({ alert, newStatus }) =>
                  dispatch(
                    Creators.updateAlertFromDetailsPage({
                      alert_id: alert?.alert_id,
                      alert_status: newStatus
                    })
                  )
                }
              />
            </Col>

            <Col flex="none">
              <Divider type="vertical" style={{ height: "100%", margin: "0 24px" }} />
            </Col>

            <Col flex="1 1 50%" className="alert-overview">
              <Flex vertical={true} gap={4} style={{ marginBottom: 24 }}>
                <Text type="secondary">{t("Order value")}</Text>
                <Text strong style={{ fontSize: 20, lineHeight: 1.4 }}>
                  <Private>{`$ ${alertDetails?.converted_amount || alertDetails?.amount}`}</Private>
                </Text>
              </Flex>
              <OverviewInfo
                data={alertDetails}
                type="fullPageRight"
                //TODO: CHA-6795
                // onOpenTransactionModal={canOpenTransactionModal ? openTransactionModal : null}
                // onSubmitAlertStatusChange={submitAlertStatusChange}
                onOpenTransactionModal={null}
                onSubmitAlertStatusChange={({ alert, newStatus }) =>
                  dispatch(
                    Creators.updateAlertFromDetailsPage({
                      alert_id: alert?.alert_id,
                      alert_status: newStatus
                    })
                  )
                }
              />
            </Col>
          </Row>

          <Text strong style={{ fontSize: 18 }}>
            {t("Alert activity")}
          </Text>

          <Table
            columns={getTableColumns}
            rowKey={"created"}
            loading={alertLogsFetching}
            dataSource={alertLogs}
            scroll={{ x: "auto" }}
            showSizeChanger={false}
            withOutPagination={true}
          />
        </Flex>
      </div>
      {/* //TODO: CHA-6795
      <TransactionModal
        open={!!transactionModalAlert}
        onClose={closeTransactionModal}
        onSave={saveTransactionModalData}
        initialValue={transactionModalInitialValue}
        saving={transactionModalSaving}
        error={transactionModalError}
        onClearError={() => dispatch(Creators.alertsSetProp('transactionModalError', null))}
        status={transactionModalAlert?.alert_status}
        connectedProcessors={transactionModalProcessors}
      />
      */}
    </Spin>
  )
}
